<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">

      <template slot="left" >
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-math-log</v-icon>{{$t('version.link.links')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <LinkForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import LinkForm from '../../components/link/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Link';

const { mapFields } = createHelpers({
  getterType: 'link/getField',
  mutationType: 'link/updateField'
});

export default {
  name: 'LinkCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    LinkForm
  },
  data() {
    return {
      item: {
        'changeLog' : this.$route.params.parent
      }
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('link', ['create', 'reset'])
  }
};
</script>
